"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const o=require("./css-color");exports.dropShadowToCss=(s=>`${s.offset.x}px ${s.offset.y}px ${s.radius}px ${o.colorToCss(s.color)}`),exports.dropShadowToFilterCss=(s=>{const r=s.radius/2;return`drop-shadow(${s.offset.x}px ${s.offset.y}px ${r}px ${o.colorToCss(s.color)})`});
//# sourceMappingURL=/@diez/web-sdk-common/lib/css-drop-shadow.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@diez/web-sdk-common/lib/css-drop-shadow.js
// module id = 413
// module chunks = 168707334958949